<ng-container *ngIf="show">
    <div [class]="svgDivClass" role="alert">
        <div class="o-alert__icon">
            <svg [class]="svgClass" aria-hidden="true" focusable="false">
                <use [attr.xlink:href]="svgPath"></use>
            </svg>
        </div>

        <h2 class="o-alert__title">{{ messageTitle }}</h2>
        <pre class="paragraphe" id="message-main-content">{{ message }}</pre>

        <button type="button" (click)="hide()" class="btn btn--close btn--icon-only">
            <svg class="svg-icon svg-close" aria-hidden="true" focusable="false">
                <use xlink:href="assets/svg-icons/icon-sprite.svg#close"></use>
            </svg>
            <span class="sr-only">Masquer ce message</span>
        </button>
    </div>
</ng-container>
